import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { TCategory } from '@api/io/categories.io';
import { TW_ROOT } from '@utils/constants';
import { cn, FaIcon } from '@fe-learner-common';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { CategoryLinkItem } from '@routes/catalog/components/Categories/CategoryLinkItem';
import { useIntl } from 'react-intl';
import { useBreakpoint } from '@fe-learner-common/hooks/useBreakpoint';

type MoreCategoriesMenuProps = {
  categories: TCategory[];
};
export const MoreCategoriesMenu = forwardRef<
  HTMLButtonElement,
  MoreCategoriesMenuProps
>(({ categories }, ref) => {
  const intl = useIntl();
  const matchesMd = useBreakpoint('md');

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          ref={ref}
          className="l-btn l-btn-md l-btn-secondary shrink-0 text-nowrap data-[state=open]:bg-neutral-300"
          aria-label={intl.formatMessage({ id: 'catalog.categories.more' })}
        >
          <span>{intl.formatMessage({ id: 'catalog.categories.more' })}</span>
          <FaIcon icon={faChevronDown} />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal
        container={document.getElementById(TW_ROOT) as HTMLElement}
      >
        <DropdownMenu.Content
          avoidCollisions
          side="bottom"
          collisionPadding={matchesMd ? 50 : 16}
          loop={true}
          className={cn(
            'mt-[20px] flex max-h-[70vh] max-w-[calc(100vw-32px)] flex-wrap gap-3 overflow-auto rounded-xl border-1 border-neutral-200 bg-neutral-0 p-4 drop-shadow-lg',
            'md:max-h-[500px] md:max-w-[600px]',
          )}
        >
          {categories.map((category) => (
            <DropdownMenu.Item key={category.id} asChild>
              <CategoryLinkItem category={category} />
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
});
MoreCategoriesMenu.displayName = 'MoreCategoriesMenu';
